// @ts-nocheck
/*
 * SSML helper primitives lifted from v1
 * `components/partials/dashboard/tts/SsmlTextEditor.js` — the pure
 * non-React exports (`SSML_TAG_TYPES`, `stripSsml`, `parseSsmlSegments`)
 * so `SsmlScriptView` and `TtsListPage` can consume them without pulling
 * in the full editor component. The editor itself (with its many hooks +
 * SCSS) is ported separately in T4 for `add-tts`.
 * All three exports are BYTE-IDENTICAL to v1.
 */

export const SSML_TAG_TYPES = [
  {
    key: 'currency',
    interpretAs: 'currency',
    label: 'Currency',
    glyph: '₹',
    border: '#6ee7b7',
    bg: '#ecfdf5',
    fg: '#059669',
    rate: 0.7,
  },
  // { key: "number", interpretAs: "number", label: "Number", glyph: "123", border: "#93c5fd", bg: "#eff6ff", fg: "#2563eb", rate: 0.8 },
  {
    key: 'digits',
    interpretAs: 'digits',
    label: 'Digits',
    glyph: '1-2-3',
    border: '#5eead4',
    bg: '#f0fdfa',
    fg: '#0d9488',
    rate: 0.5,
  },
  {
    key: 'date',
    interpretAs: 'date',
    label: 'Date',
    glyph: '31/1',
    border: '#fcd34d',
    bg: '#fffbeb',
    fg: '#b45309',
    rate: 0.8,
  },
  {
    key: 'time',
    interpretAs: 'time',
    label: 'Time',
    glyph: '9:41',
    border: '#f0abfc',
    bg: '#fdf4ff',
    fg: '#a21caf',
    rate: 0.9,
  },
  {
    key: 'telephone',
    interpretAs: 'telephone',
    label: 'Phone',
    glyph: '☎',
    border: '#67e8f9',
    bg: '#ecfeff',
    fg: '#0e7490',
    rate: 0.5,
  },
  // { key: "ordinal", interpretAs: "ordinal", label: "Ordinal", glyph: "1st", border: "#fca5a5", bg: "#fef2f2", fg: "#dc2626", rate: 0.8 },
  // { key: "characters", interpretAs: "characters", label: "Spell out", glyph: "A-B", border: "#c4b5fd", bg: "#f5f3ff", fg: "#6d28d9", rate: 0.5 },
];

const SAY_AS_RE =
  /<say-as\s+interpret-as="([^"]*)"\s+lang="([^"]*)"\s+rate="([^"]*)">([\s\S]*?)<\/say-as>/g;

export function stripSsml(value: any) {
  if (!value) return '';
  SAY_AS_RE.lastIndex = 0;
  return value.replace(
    SAY_AS_RE,
    (_full: string, _interpretAs: string, _lang: string, _rate: string, inner: string) =>
      inner,
  );
}

export function parseSsmlSegments(value: any) {
  if (!value) return [];
  const segments: any[] = [];
  let lastIndex = 0;
  let match;
  SAY_AS_RE.lastIndex = 0;
  while ((match = SAY_AS_RE.exec(value))) {
    const [full, interpretAs, lang, rate, inner] = match;
    if (match.index > lastIndex) {
      segments.push({ kind: 'text', text: value.slice(lastIndex, match.index) });
    }
    segments.push({
      kind: 'tag',
      interpretAs,
      lang,
      rate,
      text: inner,
      type: SSML_TAG_TYPES.find((t) => t.interpretAs === interpretAs) || null,
    });
    lastIndex = match.index + full.length;
  }
  if (lastIndex < value.length) {
    segments.push({ kind: 'text', text: value.slice(lastIndex) });
  }
  return segments;
}
